import type { ActivityItem, ActorKind } from '../../shared/types';

export const ACTOR_LABEL: Record<ActorKind, string> = {
  agency: 'Agentur',
  client: 'Kunde',
  guest: 'Gast',
  system: 'System',
};

/** Satz für Aktivitätsliste und Benachrichtigungen, ohne den Namen der handelnden Person. */
export function activityText(item: ActivityItem): string {
  const banner = item.bannerName ?? 'ein Motiv';
  const v = typeof item.data.versionNumber === 'number' ? ` (v${item.data.versionNumber})` : '';
  const excerpt = typeof item.data.excerpt === 'string' ? item.data.excerpt : '';
  switch (item.type) {
    case 'banner_created':
      return `hat „${banner}“ hochgeladen`;
    case 'version_added':
      return `hat eine neue Version von „${banner}“ hochgeladen${v}`;
    case 'comment':
      return `hat „${banner}“ kommentiert${excerpt ? `: „${excerpt}“` : ''}`;
    case 'reply':
      return `hat auf Feedback zu „${banner}“ geantwortet${excerpt ? `: „${excerpt}“` : ''}`;
    case 'decision_approved':
      return `hat „${banner}“ freigegeben${v}`;
    case 'decision_changes_requested':
      return `wünscht Änderungen an „${banner}“${v}`;
    case 'decision_reset':
      return `hat den Status von „${banner}“ zurückgesetzt`;
    case 'campaign_created':
      return 'hat die Kampagne angelegt';
    case 'campaign_published':
      return 'hat die Kampagne für den Kunden sichtbar gemacht';
    case 'campaign_unpublished':
      return 'hat die Kampagne für den Kunden ausgeblendet';
    case 'share_created':
      return `hat einen Freigabe-Link erstellt${item.data.label ? ` („${String(item.data.label)}“)` : ''}`;
    case 'download':
      return `hat ${String(item.data.count ?? '')} Datei(en) heruntergeladen`;
    default:
      return item.type;
  }
}
